{
	"createOrder": {
		"stopPrice": "Stop цена",
		"limitPrice": "Limit цена",
		"amountTransaction": "Примерная сумма сделки",
		"availableWithLeverage": "Доступно с плечом",
		"approximateSum": "Примерная сумма",
		"side": {
			"buy": "Купить",
			"sell": "Продать"
		},
		"errors": {
			"stopPriceZero": "Stop цена не может быть равно 0",
			"limitPriceZero": "Limit цена не может быть равно 0",
			"qtyZero": "Количество не может быть равно 0",
			"invalidTakeProfit": "Вы ввели недопустимое значение для take profit",
			"invalidStopLoss": "Вы ввели недопустимое значение для stop loss",
			"orderCreationFailed": "Не удалось создать ордер",
			"orderCreationSuccess": "Ордер {{symbol}} создан",
			"maxQty": "Значение превышает количество, доступное в вашем портфеле",
			"trailValueZero": "Значение трейла не может быть равно нулю"
		}
	}
}
